<template>
    <div class="s-nice-text">

<!--        <h1>발제자</h1>-->

        <p class="u-color-muted">가나다 순</p>

<!--        <ul class="o-list-inline  o-list-inline&#45;&#45;delimited">-->
<!--            <li class="o-list-inline__item" v-for="profile in marxism.defaultProfiles.slice(0, 8)">-->
<!--                {{ profile.name }}-->
<!--            </li>-->
<!--        </ul>-->


        <ul>
            <li v-for="profile in marxism.defaultProfiles.slice(9)">
                <div class="u-margin-bottom">
                    <em>{{ profile.name }}</em>
                    <span v-html="profile.introShort"></span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "Profile",
        props: ["profile", "marxism"],
        mixins: [require('./mixin')],
        mounted() {
            let pageTitle = '발제자 더 보기';
            document.querySelector('title').innerText = `${pageTitle} | ${this.marxism.title} - 마르크스주의 포럼`;

            if (window.gtag) {
                // for google analytics page tracking
                window.gtag('config', 'UA-2193909-1', {
                    'page_title': `${pageTitle} | ${this.marxism.title} - 마르크스주의 포럼`,
                    'page_path': (new URL(location.href)).pathname
                });
            }
        }
    }
</script>

<style scoped>

</style>
